// extracted by mini-css-extract-plugin
export var confirmLoginFieldsContainer = "confirm-login-fields-container_ohbZKpowQoL6NBn_m6cn";
export var confirmationRow = "confirmation-row_q_Bb_GHZcB__PcUPuc2d";
export var descriptionText = "description-text_bYibKNUJ4NNX8gnDIGvc";
export var docLink = "doc-link_eRg0aBp4X2FPI0atnzfX";
export var fieldMappingCard = "field-mapping-card_cCQLZBbAvKv9dBxbArJd";
export var fieldRow = "field-row_fozxIcg5VtX1L6qnIA5j";
export var helperText = "helper-text_bCmhRIHpQ8AkrN65DeL4";
export var instructionsList = "instructions-list_pU8_6j9HavooMPOG6k9u";
export var instructionsSection = "instructions-section_mHUsyfNqhrmm9YasGqEV";
export var noteList = "note-list_tKDEBtidpZhnXo9x60PT";
export var requiredMarker = "required-marker_gygB3uBlyuMi3V0iRbmo";